export default __webpack_public_path__ + "static/media/toneladas_CO2.c23b47cc.png";